import { render, staticRenderFns } from "./ImportList.vue?vue&type=template&id=10057bfb&scoped=true"
import script from "./ImportList.vue?vue&type=script&lang=js"
export * from "./ImportList.vue?vue&type=script&lang=js"
import style0 from "./ImportList.vue?vue&type=style&index=0&id=10057bfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10057bfb",
  null
  
)

export default component.exports